import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'RON',
    showEcoFee: true,
    enableEnergyLabelLink: true,
};
